export default "__VITE_ASSET__4ac331a8__"